import { reactive } from "vue";

let model;

export function setModel(_model){
    model = _model;
}

export function oneStopShopJackpotPreprocess(data){
    const MAX_ID_LENGTH = 16;

    for(let key in data){
        let provider = data[key];
        let items = {};

        provider.results.forEach(item => {
            let gameId = item.jackpotId;
            gameId = (gameId.includes('_') ? gameId.substring(0, gameId.indexOf('_')) : gameId).substring(0, MAX_ID_LENGTH);
            while(gameId.length < MAX_ID_LENGTH) gameId += '0';

            let currency = Object.keys(item.amount)[0];

            items[gameId] = {
                value: item.amount[currency] + (items[gameId]?.value || 0),
                currency,
            };
        });

        for(let key in items){
            let val = items[key];
            model.listJackpotInfo[key] = {
                value: val.value,
                currency: val.currency,
            };
        }
    }
}

export function zitroJackpotPreprocess(data){
    let items = {};

    data.jackpots.forEach(item => {
        item.games.forEach(gameId => {
            items[gameId] = {
                value: item.value + (items[gameId]?.value || 0),
                currency: item.currency,
            }
        });
    });

    for(let key in items){
        let val = items[key];
        model.listJackpotInfo[key] = {
            value: val.value / 100,
            currency: val.currency,
        };
    }
}

export function topWinPreproccess(data, formatWinMon){
    for(var i = 0, j = data.length; i < j; i++){
        var item = data[i];
        var game = this.getGameByID(item.GameId);

        /*
            It is possible that, in very rare cases, we could end up 
            with games that aren't configured on the client side.
            */
        if(!game){
            data.splice(i, 1);
            i--;
            j--;
            continue;
        }
        else
            item.GameId = game.gameId;

        item.imgError = reactive({value: false});
        item.imgPath = game.imgPath;
        item.imgPathError = game.imgPathError;
        item.dateFormatted = model.formatDateTodayYesterday(item.Date);
        item.NickName = String(item.NickName).substr(0, 3) + '***';

        item.winNumber = Number(item.Win.replace(/[^0-9]/g, ''));

        item.thumbnail = this.getThumbnail(game);
        item.gameName = game.name;
        item.Currency = item.Currency || 'EUR';

        if(formatWinMon){
            item.WinMon = model.formatAsCurrency({
                value: Number((item.WinMon + '').replace(/,/g, '')),
                isCredits: false,
                includeSymbol: false,
            });
        }
        
        item.bigWin = false;
    }
}